// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-modal {
  position: absolute;
  background-color: #ffffff;
  z-index: 10;
  right: 0;
  top: 0;

  width: calc(100% - 414px);
  max-height: 100vh;
  height: 100vh;
  padding: 24px 20px 16px 20px;

  display: flex;
  flex-direction: column;
  gap: 24px;
}

  .page-modal__body {
    height: 100%;
    min-height: 0;
    overflow: auto;
  }

  .page-modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Module/PageModal/styles.scss"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,yBAAwB;EACxB,WAAW;EACX,QAAQ;EACR,MAAM;;EAEN,yBAA+B;EAC/B,iBAAiB;EACjB,aAAa;EACb,4BAA4B;;EAE5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AAaX;;EAXE;IACE,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB","sourcesContent":["@import '../../../../assets/scss/variables.scss';\n\n.page-modal {\n  position: absolute;\n  background-color: $white;\n  z-index: 10;\n  right: 0;\n  top: 0;\n\n  width: calc(100% - $menu-width);\n  max-height: 100vh;\n  height: 100vh;\n  padding: 24px 20px 16px 20px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n\n  &__body {\n    height: 100%;\n    min-height: 0;\n    overflow: auto;\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
